(() => {
  const dialog = document.getElementById('ContactDialog');
  const overlay = document.querySelector('.contact-dialog-overlay[data-contact-dialog-close]');
  const openTriggers = document.querySelectorAll('[data-contact-dialog-open]');
  const closeTriggers = document.querySelectorAll('[data-contact-dialog-close]');

  if (!dialog || openTriggers.length === 0) return;

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let lastTrigger = null;

  const getFocusable = () => Array.from(dialog.querySelectorAll(focusableSelector))
    .filter((element) => !element.hasAttribute('hidden') && element.offsetParent !== null);

  const open = (trigger) => {
    lastTrigger = trigger || null;
    dialog.removeAttribute('inert');
    dialog.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('contact-dialog-open');
    if (overlay) overlay.hidden = false;
    openTriggers.forEach((item) => item.setAttribute('aria-expanded', 'true'));

    const result = dialog.querySelector('[data-contact-dialog-result]');
    const focusTarget = result || getFocusable()[0];
    if (focusTarget) window.setTimeout(() => focusTarget.focus(), 60);
  };

  const close = () => {
    dialog.setAttribute('aria-hidden', 'true');
    dialog.setAttribute('inert', '');
    document.documentElement.classList.remove('contact-dialog-open');
    if (overlay) overlay.hidden = true;
    openTriggers.forEach((item) => item.setAttribute('aria-expanded', 'false'));
    if (lastTrigger) lastTrigger.focus();
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      open(trigger);
    });
  });

  closeTriggers.forEach((trigger) => trigger.addEventListener('click', close));

  document.addEventListener('keydown', (event) => {
    if (dialog.getAttribute('aria-hidden') !== 'false') return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusable = getFocusable();
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (dialog.querySelector('[data-contact-dialog-result]')) open(null);
})();
